import { UPDATE_CART } from './types';
import lodash from 'lodash';
import axios from 'axios';
import { newUrl } from '../../utility';
import { setCurrentRoute } from './authActions';

export const addToCart = (cartItems, site_data) => (dispatch) =>{
    let tempCartItems = [...cartItems, ...[site_data]];
    let uniqueTempCartItems = lodash.uniqBy(tempCartItems, v=> [v._id].join());
    dispatch({
        type : UPDATE_CART,
        payload : uniqueTempCartItems
    })
}

export const removeCartItem = (cartItems, site_data) => (dispatch) => {

    let tempCartItems = cartItems.filter(item=>{
        return (item._id !== site_data._id)
    })

    dispatch({
        type : UPDATE_CART,
        payload : tempCartItems
    })
}

export const createPlanoCampaign = (cartItems, campaignName, startDate, endDate) => dispatch => {
    axios.post(newUrl+'/createPlanoCampaign', {
        cartItems : cartItems,
        campaignName : campaignName,
        startDate : startDate,
        endDate : endDate
    }, { headers: { "authorization": localStorage.getItem("plano_token") } }).then((success, error)=>{
        if(error){
            console.log(error);
        } else {
            console.log("Campaign Created ", success.data);
            dispatch({
                type : UPDATE_CART,
                payload : []
            });
            setCurrentRoute("show_created_campaign")(dispatch);
        }
    })
}


// WEBPACK FOOTER //
// ./src/v3/actions/cartActions.js